import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import Constants from "../../caseLawDocuments/common/Constants";
import { IDocumentTypeIndexCategory } from "../../documentTypes/model/DocumentTypeIndexCategory";
import DocumentTypeIndexCategoryParamMapper from "../../documentTypes/service/DocumentTypeIndexCategoryParamMapper";
import DocumentTypeIndexCategoryMapper from "../../documentTypes/service/DocumentTypeIndexCategoryMapper";

export default class GetCaseLawDocumentTypeIndexCategoriesInteractor {
  private resource: GetAllResourceEntriesInteractor<IDocumentTypeIndexCategory>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(caseLawDocumentTypeId: number, organisationId: number) {
    return this.resource.execute(
      `${Constants.organisationsPath}/${organisationId}/${Constants.caseLawDocumentTypePath}/${caseLawDocumentTypeId}/index-categories`,
      DocumentTypeIndexCategoryMapper,
      DocumentTypeIndexCategoryParamMapper
    );
  }
}
